import { IBlog } from "@types";
import { BaseAPI } from "@utils";

class BlogApi extends BaseAPI<IBlog> {}

export const blogApi = new BlogApi("/api/v1/blogs");
